import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import ClientForm from './ClientForm';

function AddClient() {
    return ( 
       <Container>
        <Navbar/>

        <Content>

            <ClientForm/>
        </Content>
       </Container>
     );
}

export default AddClient;